import { render, staticRenderFns } from "./InlineVideo.vue?vue&type=template&id=604b896d"
import script from "./InlineVideo.vue?vue&type=script&lang=js"
export * from "./InlineVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports